import React, { useState } from "react";
import Header from "./Header";
import MobileMenu from "./MobileMenu";
import Footer from "./Footer"

const Layout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <Header
        onMenuOpen={() => setMenuOpen(true)}
        onClose={() => setMenuOpen(false)}
        isMenuOpen={menuOpen}
      />

      <MobileMenu
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
      />

      <main>{children}</main>
      <Footer/>
    </>
  );
};

export default Layout;
